module.exports = __webpack_public_path__ + "static/board-08-ed06d90ad1a9e94a75fd320b924b6996.jpg";